/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown>, min: NonNullable<unknown> }} Daily_Challenge_TimerInputs */

const en_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Refresh in ${i?.hour}h ${i?.min}m`)
};

const ar_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تحديث خلال ${i?.hour} س ${i?.min} د`)
};

const de_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktualisierung in ${i?.hour} Std. ${i?.min} Min.`)
};

const es_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualización en ${i?.hour}h ${i?.min}m`)
};

const fr_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Actualisation dans ${i?.hour}h ${i?.min}m`)
};

const it_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aggiornamento tra ${i?.hour}h ${i?.min}min`)
};

const ja_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}時間${i?.min}分後に更新`)
};

const ko_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}시간 ${i?.min}분 후 새로고침`)
};

const pt_br_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Atualização em ${i?.hour}h ${i?.min}m`)
};

const ru_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обновление через ${i?.hour} ч. ${i?.min} мин.`)
};

const th_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`รีเฟรชในอีก ${i?.hour} ชม. ${i?.min} น.`)
};

const tr_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} sa ${i?.min} dk içinde yenileniyor`)
};

const zh_cn_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 小时 ${i?.min} 分后刷新`)
};

const zh_tw_daily_challenge_timer = /** @type {(inputs: Daily_Challenge_TimerInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 小時 ${i?.min} 分後更新`)
};

/**
* | output |
* | --- |
* | "Refresh in {hour}h {min}m" |
*
* @param {Daily_Challenge_TimerInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_challenge_timer = /** @type {((inputs: Daily_Challenge_TimerInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Challenge_TimerInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_challenge_timer(inputs)
	if (locale === "ar") return ar_daily_challenge_timer(inputs)
	if (locale === "de") return de_daily_challenge_timer(inputs)
	if (locale === "es") return es_daily_challenge_timer(inputs)
	if (locale === "fr") return fr_daily_challenge_timer(inputs)
	if (locale === "it") return it_daily_challenge_timer(inputs)
	if (locale === "ja") return ja_daily_challenge_timer(inputs)
	if (locale === "ko") return ko_daily_challenge_timer(inputs)
	if (locale === "pt_br") return pt_br_daily_challenge_timer(inputs)
	if (locale === "ru") return ru_daily_challenge_timer(inputs)
	if (locale === "th") return th_daily_challenge_timer(inputs)
	if (locale === "tr") return tr_daily_challenge_timer(inputs)
	if (locale === "zh_cn") return zh_cn_daily_challenge_timer(inputs)
	return zh_tw_daily_challenge_timer(inputs)
});